/* ==========================================================================
   ORW Header - Sticky scroll + Mobile drawer
   ========================================================================== */

(function () {
  'use strict';

  function initStickyScroll(header) {
    var onScroll = function () {
      if (window.scrollY > 10) {
        header.classList.add('orw-header--scrolled');
      } else {
        header.classList.remove('orw-header--scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Drawer open/close via document-level event delegation. This way the
     handler works even if the drawer DOM is injected after init runs
     (theme editor re-renders, section rendering API, etc.) -- previously
     the per-button addEventListener bind missed the buttons in some
     contexts and clicks did nothing. */
  function initDrawer() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest && e.target.closest('[data-orw-drawer-toggle]');
      if (!toggle) return;
      var drawer = document.querySelector('[data-orw-drawer]');
      if (!drawer) return;
      e.preventDefault();
      var willOpen = !drawer.hasAttribute('open');
      if (willOpen) {
        drawer.setAttribute('open', '');
        document.body.style.overflow = 'hidden';
      } else {
        drawer.removeAttribute('open');
        document.body.style.overflow = '';
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var drawer = document.querySelector('[data-orw-drawer]');
      if (drawer && drawer.hasAttribute('open')) {
        drawer.removeAttribute('open');
        document.body.style.overflow = '';
      }
    });
  }

  /* Move the drawer to be a direct child of <body>. Shopify wraps every
     section in <div class="shopify-section ..."> which sometimes gets
     positioned/transformed by Dawn or page-builder layers and creates a
     stacking context that traps the drawer's z-index below sibling
     sections (e.g. hero tabs end up rendering above the drawer panel
     even though drawer is z-modal 300). Lifting it to <body> guarantees
     it's at the document's root stacking context. */
  function liftDrawerToBody() {
    var drawer = document.querySelector('[data-orw-drawer]');
    if (!drawer) return;
    if (drawer.parentElement === document.body) return;
    document.body.appendChild(drawer);
  }

  function init() {
    var header = document.querySelector('[data-orw-header]');
    if (header) {
      initStickyScroll(header);
    }
    initDrawer(); /* always wire delegation, even before drawer renders */
    liftDrawerToBody();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
